import React, { useEffect } from "react";
import * as microsoftTeams from "@microsoft/teams-js";

export default function AuthCallback() {
  useEffect(() => {
    microsoftTeams.app.initialize().then(() => {
      const urlParams = new URLSearchParams(window.location.search);
      const adminConsent = urlParams.get("admin_consent");
      const tenant = urlParams.get("tenant");
      const error = urlParams.get("error");
      const errorDescription = urlParams.get("error_description");

      if (adminConsent === "True") {
        microsoftTeams.authentication.notifySuccess(JSON.stringify({
          ok: true,
          tenant: tenant
        }));
      } else if (error) {
        microsoftTeams.authentication.notifyFailure(errorDescription || error);
      } else {
        // Fallback check
        if (window.location.hash && window.location.hash.includes("error=")) {
           microsoftTeams.authentication.notifyFailure("consent_failed");
        } else {
           microsoftTeams.authentication.notifySuccess(JSON.stringify({ ok: true }));
        }
      }
    });
  }, []);

  return (
    <div style={{ textAlign: "center", marginTop: "50px" }}>
      <p>Đang xử lý kết quả xác thực...</p>
    </div>
  );
}
